
interface IProps {
    showMenu: boolean
    children: React.ReactNode
}

const SideNav = ({ children, showMenu }: IProps) => {

    return (
        <div className={showMenu ? 'flex-left sideBarOpen' : 'flex-left sideBarClosed'}>
            <div style={{ position: 'sticky', top: '70px' }}>
                {children}
            </div>
        </div>
    )
}

export default SideNav